export default "__VITE_ASSET__CMH$p3dV__"